(() => {
  const init = root => {
    root.querySelectorAll('[data-c21-tabs]:not([data-ready])').forEach(section => {
      section.dataset.ready = 'true';
      const tabs = [...section.querySelectorAll('[role="tab"]')];
      const select = tab => {
        tabs.forEach(item => { item.setAttribute('aria-selected', String(item === tab)); item.tabIndex = item === tab ? 0 : -1; section.querySelector('#' + item.getAttribute('aria-controls')).hidden = item !== tab; });
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', e => {
          let next;
          if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { e.preventDefault(); select(tabs[next]); tabs[next].focus(); }
        });
      });
    });
    root.querySelectorAll('[data-c21-slideshow]:not([data-ready])').forEach(section => {
      section.dataset.ready = 'true';
      const slides = [...section.querySelectorAll('[data-c21-slide]')];
      const dots = [...section.querySelectorAll('[data-c21-slide-to]')];
      let index = 0, paused = false;
      const show = i => { index = (i + slides.length) % slides.length; slides.forEach((slide, j) => slide.hidden = index !== j); dots.forEach((dot,j) => dot.setAttribute('aria-pressed', String(index === j))); };
      section.querySelector('[data-c21-slide-prev]')?.addEventListener('click', () => show(index - 1));
      section.querySelector('[data-c21-slide-next]')?.addEventListener('click', () => show(index + 1));
      dots.forEach((dot,i) => dot.addEventListener('click', () => show(i)));
      section.querySelector('[data-c21-slide-pause]')?.addEventListener('click', e => { paused = !paused; e.currentTarget.textContent = paused ? '▶' : 'Ⅱ'; e.currentTarget.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow'); });
      if (section.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches) setInterval(() => { if (section.isConnected && !paused && !document.hidden && !section.matches(':hover,:focus-within')) show(index + 1); }, Number(section.dataset.interval));
      section.addEventListener('keydown', e => { if (e.target !== section) return; if (e.key === 'ArrowRight') show(index+1); if (e.key === 'ArrowLeft') show(index-1); });
    });
    if (location.pathname.endsWith('/pages/faqs')) {
      const content = root.querySelector('.c21-page-layout .page-content rte-formatter');
      if (content && !content.dataset.ready) {
        const source = content.innerHTML.replace(/<br[^>]*>/gi, '\n');
        const temp = document.createElement('div'); temp.innerHTML = source;
        const lines = temp.textContent.split('\n').map(s => s.trim()).filter(Boolean);
        const entries = [];
        lines.forEach(line => { if (/^\d+\.\s/.test(line)) entries.push({q:line.replace(/^\d+\.\s*/,''),a:[]}); else if (entries.length) entries.at(-1).a.push(line.replace(/^\*\s*/,'')); });
        if (entries.length) {
          content.replaceChildren(); content.dataset.ready = 'true';
          entries.forEach(entry => { const details = document.createElement('details'), summary = document.createElement('summary'), answer = document.createElement('div'); summary.textContent = entry.q; answer.textContent = entry.a.join(' '); details.append(summary,answer); content.append(details); });
        }
      }
    }
  };
  const footerMedia = matchMedia('(max-width: 749px)');
  const setFooter = () => document.querySelectorAll('.c21-footer-v2__links>details').forEach(item => item.open = !footerMedia.matches);
  setFooter(); footerMedia.addEventListener('change', setFooter);
  document.addEventListener('shopify:section:load', setFooter);
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-c21-open-chart]');
    if (trigger) { e.preventDefault(); const dialog = document.getElementById(trigger.dataset.c21OpenChart); if (dialog && !dialog.open) { dialog.querySelectorAll('.c21-chart-category').forEach(category => category.open = false); dialog.showModal(); dialog.dataset.trigger = trigger.dataset.c21OpenChart; } }
    const closer = e.target.closest('[data-c21-close-chart]');
    if (closer) closer.closest('dialog').close();
    if (e.target.matches('dialog.c21-chart')) { const r = e.target.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close(); }
    const order = e.target.closest('[data-c21-order-history]');
    if (order) {
      const context = document.querySelector('[data-c21-account-route]');
      const route = context?.dataset.c21AccountRoute || '/account';
      const destination = new URL(route, location.origin).href;
      if (context?.dataset.c21Customer === 'true') location.assign(destination);
      else if (typeof window.handleShopifyLogin === 'function') window.handleShopifyLogin(e, destination, true);
      else location.assign(destination);
    }
  });
  document.querySelectorAll('dialog.c21-chart').forEach(dialog => dialog.addEventListener('close', () => document.querySelector('[data-c21-open-chart="' + dialog.id + '"]')?.focus()));
})();
